import posthog from "posthog-js";
import { useCallback, useSyncExternalStore } from "react";

/**
 * Reactively read a PostHog feature flag.
 *
 * Subscribes to PostHog's flag updates via `useSyncExternalStore` so the value
 * stays current when flags load or change, without a `useEffect`. Returns
 * `false` during SSR and until flags resolve on the client.
 */
export function useFeatureFlag(flagKey: string): boolean {
	const subscribe = useCallback((onChange: () => void) => {
		return posthog.onFeatureFlags(onChange);
	}, []);

	const getSnapshot = useCallback(() => {
		return posthog.isFeatureEnabled(flagKey) ?? false;
	}, [flagKey]);

	return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
